import { useQuery } from '@apollo/client';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useActiveDocument } from 'shared/domains/documents';
import { AttachmentButtonQueryDocument } from './AttachmentButtonQuery.gql';
import { EndElement } from './EndElement';
import { ListButton } from '../ListButton';
export function AttachmentsButton() {
    const { id } = useActiveDocument();
    const { data, loading } = useQuery(AttachmentButtonQueryDocument, {
        variables: { id },
    });
    const { attachmentsCount } = (data === null || data === void 0 ? void 0 : data.fileSystemDocument) || {};
    return (<ListButton loading={loading} settingsKey="attachments" icon={<Falcon icon="paperclip"/>} endElement={!loading && <EndElement attachmentsCount={attachmentsCount || 0}/>}/>);
}
